<h2>Attributes</h2>
<p-table #dt [value]="attributes" expandableRows="true" [globalFilterFields]="['gender','eyeColor','hairColor','displayHeight','displayWeight','updatedDate','updatedBy']">
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="7">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th>Gender</th>
            <th>Eye Color</th>
            <th>Hair Color</th>
            <th>Height</th>
            <th>Weight</th>
            <th>Updated</th>
            <th>Updated By</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-expanded="expanded" let-data>
        <tr [pSelectableRow]="data">
            <td>{{data.gender}}</td>
            <td>{{data.eyeColor}}</td>
            <td>{{data.hairColor}}</td>
            <td>{{data.displayHeight}}</td>
            <td>{{data.displayWeight}}</td>
            <td>{{data.updatedDate | dateTime}}</td>
            <td class="td--hover-show">{{data.updatedBy}}</td>
        </tr>
    </ng-template>
</p-table>
